import Markdown from 'react-markdown'
import { Heading as BaseHeading, HeadingProps } from 'blaze-ui/Heading/Heading'
import { TextMessageRendererProps } from '../Types'
import { PropsWithChildren } from 'react'
import Styles from './TextMessageRenderer.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Paragraph as BaseParagraph } from 'blaze-ui/Paragraph/Paragraph'
import cx from 'classnames'
import { UnorderedListProps } from 'react-markdown/lib/ast-to-react'

const Heading = ({ children, ...props }: PropsWithChildren<HeadingProps>) => (
  <div className={cx(Styles.headingContainer, Styles[`level${props.level}`])}>
    <BaseHeading {...props}>{children}</BaseHeading>
  </div>
)

const Ul = ({ children, ...props }: PropsWithChildren<UnorderedListProps>) => (
  <ul className={cx(Styles.ul, Styles[`depth${props.depth}`])}>{children}</ul>
)

const Li = ({ children }: PropsWithChildren) => (
  <li className={Styles.li}>
    <Text variant="secondary" color="var(--dark-80)">
      {children}
    </Text>
  </li>
)
const Paragraph = ({ children }: PropsWithChildren) => (
  <div className={Styles.paragraph}>
    <BaseParagraph variant="secondary" color="var(--dark-80)">
      {children}
    </BaseParagraph>
  </div>
)

export const TextMessageRenderer = ({ children }: TextMessageRendererProps) => {
  return (
    <Markdown
      components={{
        h1({ children }) {
          return <Heading level={1}>{children}</Heading>
        },
        h2({ children }) {
          return <Heading level={2}>{children}</Heading>
        },
        h3({ children }) {
          return <Heading level={3}>{children}</Heading>
        },
        h4({ children }) {
          return <Heading level={4}>{children}</Heading>
        },
        h5({ children }) {
          return <Heading level={5}>{children}</Heading>
        },
        ul({ children, ...props }) {
          return <Ul {...props}>{children}</Ul>
        },
        li({ children }) {
          return <Li>{children}</Li>
        },
        p({ children }) {
          return <Paragraph>{children}</Paragraph>
        },
        hr() {
          return <hr className={Styles.hr} />
        },
      }}
    >
      {children}
    </Markdown>
  )
}
